import React, { useCallback, useMemo, useRef, useState, useEffect } from "react";
import excelIcon from '../../../assets/images/excel.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoaderComponent from "../../../libraries/loader/loader";
import { Readmails,getvendorcode, getBalanceFromServer,Fetchbankinvoicedetails1,updateclosurestatusvalue,Fetchexecutequery,Fetchselectivebankinvoicedetails,Fetchbankinvoicedetails12,updatedonutvalue,Fetchexternaldetails,Fetchexternaldetails1, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetchbankinvoicedetails_1, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew, getdataforcardsrecon } from '../../../services/process/BRS1/arservice';


import axios from "axios";
import ReactApexChart from "react-apexcharts";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileLines, faStreetView } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import Modal from 'react-bootstrap/Modal';
import { Icon, Input, Button,Divider, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import RenderGrid from './grid';
import "./reconSummary.css";
// import DynamicDonutChart from './donutchart';


function ReconSummary() {
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [options, setOptions] = useState([]);
  const [clientids, setclientids] = useState([]);
  const [clientids1, setclientids1] = useState([]);
  const [showModal, setShowModal] = useState(false); 
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  const [chartHidden, setChartHidden] = useState(true);
  const [doughnutLabel, setDoughnutLabel] = useState([]);
  const [doughnutdata, setDoughnutData] = useState([]);
  const [label, setLabel] = useState('');
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [searchHidden, setSearchHidden] = useState(true);
  const [intGridData, setIntGridData] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [intDebit, setIntDebit] = useState(0.00);
  const [intCredit, setIntCredit] = useState(0.00);
  const [extDebit, setExtDebit] = useState(0.00);
  const [extCredit, setExtCredit] = useState(0.00);
  const [intDate, setIntDate] = useState(undefined);
  const [extDate, setExtDate] = useState(undefined);
  const [amountTolerance, setAmountTolerance] = useState(0.00);
  const [openGridHidden, setOpenGridHidden] = useState(true);
  const [openIntGridData, setOpenIntGridData] = useState([]);
  const [openExtGridData, setOpenExtGridData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const agIntGridRef = useRef(null);
  const agExtGridRef = useRef(null);
  const intMatchingRows = [];
  const extMatchingRows = [];
  const [internalAmount, setInternalAmount] = useState(0.00);
  const [externalAmount, setExternalAmount] = useState(0.00);
  const [matchHidden, setMatchHidden] = useState(true);
  const [contraHidden, setContraHidden] = useState(true);
  const [duplicateHidden, setDuplicateHidden] = useState(true);
  const [unMatchHidden, setUnMatchHidden] = useState(true);
  const [intId, setIntId] = useState('');
  const [intName, setIntName] = useState("");
  const [extName, setExtName] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [unMatchStyles, setUnMatchStyles] = useState(undefined);
  const [selectCheckBox, setSelectCheckBox] = useState(undefined);
  const [searchText, setSearchText] = useState('');
  const [hideLabels, setHideLabels] = useState(false);
  // const chartRef = useRef(null);

  const [arcolumnnames, setarcolumnnames] = useState([]);
  const [bankcolumnnames, setbankcolumnnames] = useState([]);

  const [modelcolumnnames, setmodelcolumnnames] = useState([]);
  const [modelcolumnnames1, setmodelcolumnnames1] = useState([]);
  const [modelnames1, setmodelnames1] = useState([]);
  

  const [show3, setShow3] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);

  const [matchedData, setMatchedData] = useState({});
  const [unmatcheddata, setunmatcheddata] = useState({});
  const [alldata, setalldata] = useState({});
  const [bank_advice_location, setbank_advice_location] = useState('');

  

  const [selectedLabel, setSelectedLabel] = useState('');
  

  const [finalinternaldata, setfinalinternaldata] = useState([]);
  const [finalexternaldata, setfinalexternaldata] = useState([]);
  const [ismatched, setismatched] = useState({});


  const [customer_advice_location, setcustomer_advice_location] = useState('');

  const [overdue, setoverdue] = useState('');
  const [outstanding, setoutstanding] = useState('');
  const [total, settotal] = useState('');

  const [optionslist, setOptionslist] = useState([]);

  const [matchidslist, setmatchidslist] = useState([]);


  const [remarkscol, setremarkscol] = useState([]);
  const [remarksdata, setremarksdata] = useState([]);

  const [remarkscol1, setremarkscol1] = useState([]);
  const [remarksdata1, setremarksdata1] = useState([]);

  const [dropdown1, setdropdown1] = useState({ value: "Day", label: "Day" });
  const [dropdown2, setdropdown2] = useState({});

  const [userid, setuserid] = useState(userCredentials["user_id"]);


  const [barwidth, setbarwidth] = useState('40%');
  const [barwidth1, setbarwidth1] = useState('40%');

  const payment_history_dropdowns = [
    { value: "Day", label: "Day" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ];

  const payment_history_dropdowns1 = [
    { value: "This week", label: "This week" },
    { value: "This month", label: "This month" },
    { value: "Last week", label: "Last week" },
    { value: "Last month", label: "Last month" },
    { value: "Last 2 month", label: "Last 2 month" },
    { value: "Last 6 month", label: "Last 6 month" },
  ];


  const changedropdown2 = (event) => {
    setdropdown2(event)
  }

  const chartData1 = {
    labels: doughnutLabel,
    series: doughnutdata,
  };



  const internaltotal1 = React.useMemo(() => {
    if (openIntGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      let total = 0.0;
      openIntGridData.forEach((row) => {
        // console.log('row',row.GL_CREDIT,row.GL_DEBIT);
        total = total + (parseFloat(row["Invoice Amount"]));
        console.log('row',total)
      })
      console.log('total13',total)
      const usFormatter = new Intl.NumberFormat("en-IN");
      total = usFormatter.format(total)
      setInternalAmount(total);
      console.log('total123',total)
      // console.log('intColumnDefs', intColumnDefs);
      return [];
    }

    return [];
  }, [openIntGridData]);

  const externaltotal1 = React.useMemo(() => {
    if (openExtGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      let total = 0.0;
      openExtGridData.forEach((row) => {
        // Parse 'Debit' to integer and add to total
        total = total + (parseFloat(row.AMOUNT));
      });
      const usFormatter = new Intl.NumberFormat("en-IN");
      total = usFormatter.format(total)
      
      setExternalAmount(total);
      
      return [];
    }

    return [];
  }, [openExtGridData]);


  const DynamicDonutChart = ({ options, series, onClick }) => {

    const handleDataPointSelection = (event, chartContext, config) => {
      console.log('Data:', chartData.series, chartData.options.labels);
      console.log('Event:', event);
      if (config && config.w && config.w.config && config.w.config.labels && config.dataPointIndex !== undefined) {
        const selectedLabel = config.w.config.labels[config.dataPointIndex];
        if (selectedLabel) {
          console.log('selectedLabel', selectedLabel);
          onClick(selectedLabel);
        }
      }
    };
    const chartData = {
      series: series,
      options: {
        labels: options,
        colors: ['#264be0', '#5a63c4', '#0A2352', '#b84dff', '#ff944d', '#00cccc'],
        legend: {
          onItemClick: {
            toggleDataSeries: false,
          },

        },
        chart: {
          width: 280,
          height: 370,
          type: 'donut'
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270
          },
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'gradient',
        },
        
        title: {
          text: ''
        },

        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
              height: 250,
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        chart: {
          events: {
            dataPointSelection: handleDataPointSelection
          }
        }
      },
    };

    useEffect(() => {
      if (chartData.series.length > 0) {
        // Reinitialize the chart when data is available
        chartData.options.chart.events = {
          dataPointSelection: handleDataPointSelection
        };
      }
    }, [chartData.series]);

    console.log('options',chartData.options,chartData.series)

    console.log('options', chartData.options);
    console.log('series', chartData.series);
  
    // Check container existence
    useEffect(() => {
      const container = document.getElementById('chart-container');
      console.log('Container exists:', !!container);
    }, []);

    return (
      <div id="chart-container" style={{ marginLeft: '-50px' }}>
        <ReactApexChart options={chartData.options} series={chartData.series} height={190}type="donut" />
      </div>
    );
  };

  const [selectedDate, setSelectedDate] = useState('');

  // Function to handle the change in the date input
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value); // Update the selected date in state
  };

  // const updatestatuscolumn = (selectedLabel) => {
    
  //     const intern_id_1 = openIntGridData.map(item => item.primary_id);
  //     const intern_id = `(${intern_id_1.join(', ')})`;
  //     console.log(intern_id)

  //     const extern_id_1 = openExtGridData.map(item => item.primary_id);
  //     const extern_id = `(${extern_id_1.join(', ')})`;

  //     let payload = {
  //       "schema_name" : "account_receivable",
  //       "extern_table" : "hdfc_internal_2",
  //       "intern_table" : "internal_statement_3",
  //       "set_column" : {"status" : selectedLabel.value},
  //       // "intern": {"primary_id": openIntGridData.map(item => item.primary_id)},
  //       'intern': [{ 'primary_id': intern_id }],
  //       // "extern": openExtGridData.map(item => ({ "primary_id": item.primary_id }))
  //       "extern": [{ 'primary_id': extern_id }]
  //     }

  //     console.log('payload', payload);
  //     var getProcessingLayerDataWithStatus = updatestatusvalue();

  //     return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
  //       .then(
  //         response => {
  //           console.log("Processing Layer Data With Status!!!", response)

  //         }
  //       ).catch(
  //         error => {
  //           console.log("Error in Processing Layer Data WIth Status!!!", error);
  //         }
  //       );
  // }

  const updatestatuscolumn = (ismatched, externalAmount, internalAmount) => {

      const intern_id_1 = openIntGridData.map(item => item.primary_id);
      const intern_id = `(${intern_id_1.join(', ')})`;
      console.log('intern_id',intern_id)

      const extern_id_1 = openExtGridData.map(item => item.primary_id);
      const extern_id = `(${extern_id_1.join(', ')})`;
    
      const payload = {
        "schema_name": "account_receivable_1",
        "extern_table": "bank_alert",
        "intern_table": "invoices",
        "set_column": { "status": ismatched.value},
        'where': [{ "primary_id" : intern_id }],
        'where1': [{ "primary_id": extern_id}],
      };

      const payload1 = {
        "schema_name": "account_receivable",
        "extern_table": "hdfc_internal_2",
        "set_column": { "customer_name": ismatched.value},
        'where1': [{ "primary_id": extern_id}]
      };
  
      console.log('payload', payload,);
      const getProcessingLayerDataWithStatus = updatestatusvalue();
  
      return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
        .then(
          response => {
            alert('Records Updated Successfully!!!');
            console.log("Processing Layer Data With Status!!!", response);
          }
        ).catch(
          error => {
            alert('Error in Records Updation!!!');
            console.log("Error in Processing Layer Data With Status!!!", error);
          }
        )
    // } else {
      // alert('Total Mismatch!!!');
    //   console.log('Total not equal');
    //   setShowModal(true);
      
      // You may want to handle displaying a message to the user here
    // }
  };

  const updatecustomernames = (ismatched) => {

    const intern_id_1 = openIntGridData.map(item => item.primary_id);
    const intern_id = `(${intern_id_1.join(', ')})`;
    console.log('intern_id',intern_id)

    const extern_id_1 = openExtGridData.map(item => item.primary_id);
    const extern_id = `(${extern_id_1.join(', ')})`;

    const payload = {
      "schema_name": "account_receivable",
      "extern_table": "hdfc_internal_2",
      "intern_table": "internal_statement_3",
      "set_column": { "customer_name": ismatched.value},
      'where':  [{ "primary_id" : intern_id }],
      'where1': [{ "primary_id": extern_id}],
    };



    console.log('payload', payload,);
    const getProcessingLayerDataWithStatus = updateclosurestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          alert('Records Updated Successfully!!!');
          console.log("Processing Layer Data With Status!!!", response);
        }
      ).catch(
        error => {
          alert('Error in Records Updation!!!');
          console.log("Error in Processing Layer Data With Status!!!", error);
        }
      )
  // } else {
    // alert('Total Mismatch!!!');
  //   console.log('Total not equal');
  //   setShowModal(true);
    
    // You may want to handle displaying a message to the user here
  // }
};

  
  const updateclosurestatus = () => {

  
      const payload = {
        "schema_name": "account_receivable",
        "extern_table": "hdfc_internal_2",
        "intern_table": "internal_statement_3",
        "set_column": { "close_status": 1 },
        'where': [{ 'SUPPLIER_CODE': selectedOption.label,'DIVISION_NAME':selectedOption1.label }],
        'where1': [{ 'supplier_code': selectedOption.label,'division':selectedOption1.label}],

      };
  
      console.log('payload', payload,);
      const getProcessingLayerDataWithStatus = updateclosurestatusvalue();
  
      return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
        .then(
          response => {
            alert('Records Updated Successfully!!!');
            console.log("Processing Layer Data With Status!!!", response);
          }
        ).catch(
          error => {
            alert('Error in Records Updation!!!');
            console.log("Error in Processing Layer Data With Status!!!", error);
          }
        )
    // } else {
      // alert('Total Mismatch!!!');
    //   console.log('Total not equal');
    //   setShowModal(true);
      
      // You may want to handle displaying a message to the user here
    // }
  };

  const ClickSaveButton = () => {
    updatestatuscolumn(ismatched, externalAmount, internalAmount);
  }
  const ClickcloseButton = () => {
    updateclosurestatus();
  }
  const ClickassignButton = () => {
    updatecustomernames(ismatched);
    console.log('value', ismatched);
  }

  const [selectedval, setselectedval] = useState('');

  
  const handleSelectionmatched = (event) => {
    setismatched(event);
    setselectedval(event.label)
  }

  const handleSelectionmatched1 = () => {
    console.log('called', selectedOption, selectedOption1, options);

  }

  const [isMultiSelect, setisMultiSelect] = useState('single');

  // useEffect(() => {
  //   console.log('isMultiSelect after state update:', isMultiSelect);
  // }, [isMultiSelect]);

  


  const handleChartClick = (label) => {
    // console.log('Before state update - Label:', label, 'isMultiSelect:', isMultiSelect);
    console.log('label', label);
    // if(label == 'Open'){
    //   setisMultiSelect('multiple')
    // }else{
    //   setisMultiSelect('single')
    // }

    // setisMultiSelect('multiple')
    

    if(label == 'All'){
      Fetchbankinfo_(label)
      Fetchbankinfo_1(label)
      fetchstatuscolumntypeslist(label);
    }else if(label == 'Unallocated Credits'){
      Fetchbankinfo_2(label)
      Fetchbankinfo_5(label)
      fetchstatuscolumntypeslist(label)
    }else{
      Fetchbankinfo(label)
      Fetchbankinfo1(label)
      fetchstatuscolumntypeslist(label);
    }

    setUnMatchedHidden(false);
  
    // setUnMatchHidden(false);
    
    // setSelectedLabel(label);
    // handleSelectionmatched1();
    // Fetchbankinfo(clientids1);
    // if(label == 'Matched'){
    //   const filterKey = "Matched";
    //   const filteredData = finalinternaldata.filter(item => item.status === filterKey);
    //   const filteredData1 = finalexternaldata.filter(item => item.status === filterKey);
    //   console.log(finalinternaldata, finalexternaldata, intGridData);
    //   // console.log('matcheddata', matchedData);
    //   // setIntGridData(matchedData['internal_data'])
    //   // setExtGridData(matchedData['external_data'])
    //   setUnMatchHidden(false);
    //   setUnMatchedHidden(false);
    // }
    // else if(label == 'Open'){
    //   setIntGridData(unmatcheddata['internal_data'])
    //   setExtGridData(unmatcheddata['external_data'])
    //   setUnMatchHidden(false);
    //   setUnMatchedHidden(false);
    // }else{
    //   setIntGridData(alldata['internal_data'])
    //   setExtGridData(alldata['external_data'])
    //   setUnMatchHidden(false);
    //   setUnMatchedHidden(false);
    // }
  };

  const intColumnDefs3 = React.useMemo(() => {
    if (modelcolumnnames1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(modelcolumnnames1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
      console.log('intColumnDefs',intColumnDefs)
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    } 
    return [];
  }, [modelcolumnnames1]);

  function getgridClickedDataReturn(selectedLabel) {
    let payload = {
      
      "match_id": selectedLabel,

    }

    var getProcessingLayerDataWithStatus = Fetchexternaldetails();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          let data = response["data"];
          let bank_advice_location1 = data[0]['bank_advice_location'];
          let customer_advice_location1 = data[0]['customer_advice_location'];
          setbank_advice_location(bank_advice_location1);
          setcustomer_advice_location(customer_advice_location1);
          console.log('data', data);
          setmodelcolumnnames1((prevState) => [
            ...prevState,
            ...data]);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

  const intColumnDefs1 = React.useMemo(() => {
    if (intGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(intGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key.replace(/_/g, ' '),
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130
        })),
      ];
      setarcolumnnames(intColumnDefs);
      console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [intGridData]);

  const intColumnDefs10 = React.useMemo(() => {
    if (extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130
        })),
      ];
      setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [extGridData]);


  const handleOpenModal = () => {
    setModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };


  const intColumnDefs2 = React.useMemo(() => {
    if (remarksdata1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(remarksdata1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
      setremarkscol1(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [remarksdata1]);



  const fetchmonthwisedataAll = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = fetchmonthwisedatanew();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response fetch month wise data new!!!", response);
            let data = response["data"];
            let data1 = data['data'];
            setremarksdata1(data1);
            setShow6(true);
          }

        )
        .catch((error) => {

          console.error("Error in POST request:", error);
        });
    }
  }


  const fetchpaymenthistoryAll = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
        'key': dropdown1.value
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = getpaymenthistorynew();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response get payment history data new!!!", response);
            let data = response["data"];
            let data1 = data['data'];
            setremarksdata1(data1);
            setShow6(true);

          }

        )
        .catch((error) => {

          console.error("Error in POST request:", error);
        });
    }
  }

  const handleBarClick = () => {
    fetchmonthwisedataAll(selectedOption1)
  };

  const handleBarClick1 = () => {
    fetchpaymenthistoryAll(selectedOption1)
  };

  const labelslist = [];
  const seriesdata = [];

  const [barlabellist, setbarlabellist] = useState([]);
  const [barserieslist, setbarserieslist] = useState([]);

  const chartData5 = {
    series: [
      {
        name: 'Series 1',
        data: barserieslist,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 200,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth1
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barlabellist,
      },
      fill: {
        colors: ['#3B3C36'],
      },
    },
  };

  const BarChart = () => {
    const options = {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: barlabellist,
        fill: {
          colors: ['#0a2352'],
        },
      },
    };

    const series = [
      {
        name: 'Month wise data',
        data: barserieslist,

      }

    ];

    return (
      <div>

        <ReactApexChart options={chartData5.options} series={chartData5.series} type="bar" height={175} onClick={handleBarClick} />
      </div>
    );
  };


  const [barlabellist1, setbarlabellist1] = useState([]);
  const [barserieslist1, setbarserieslist1] = useState([]);


  const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: barserieslist1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 300,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barlabellist1,
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const BarChart1 = () => {
    const options = {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: barlabellist1,
        fill: {
          colors: ['#0a2352'],
        },
      },
    };

    const series = [
      {
        name: 'Month wise data',
        data: barserieslist1,
      }

    ];

    return (
      <div>

        <ReactApexChart options={chartData2.options} series={chartData2.series} type="bar" height={150} onClick={handleBarClick1} />
      </div>
    );
  };

  const fetchmonthwisedata = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = fetchmonthwisedata1();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response fetch month wise data!!!", response);
            let data = response["data"];
            let data1 = data['data']

            const ageBuckets = data1.map(item => item.AgeBucket);
            const totalInvoiceAmounts = data1.map(item => item.TotalInvoiceAmount);
            // setDoughnutData([60, 30, 150])
            setChartHidden(false);
            setbarlabellist(ageBuckets);
            setbarserieslist(totalInvoiceAmounts);

            let arrayLength = [];
            let datesArray = ageBuckets;
            arrayLength = datesArray.length;

            if (arrayLength == 3) {
              setbarwidth1('40%')
            } else if (arrayLength == 2) {
              setbarwidth1('30%')
            } else if (arrayLength == 4) {
              setbarwidth1('45%')
            } else if (arrayLength == 5) {
              setbarwidth1('50%')
            } else {
              setbarwidth1('10%')
            }

          }

        )
        .catch((error) => {
          // setDoughnutData([60, 30, 150])
          setChartHidden(false);
          console.error("Error in POST request:", error);
        });
    }
  }


  const fetchpaymenthistory = (event, param) => {
    if (event) {
      let payload = {
        'client_ids': event,
        'key': param
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = getpaymenthistory();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response get payment history data!!!", response);
            let data = response["data"];

            // setDoughnutData([60,30,150])
            setChartHidden(false);
            setbarlabellist1(data['labels']);
            setbarserieslist1(data['values']);
            let arrayLength = [];
            let datesArray = data['labels'];
            arrayLength = datesArray?.length;

            if (arrayLength == 3) {
              setbarwidth('40%')
            } else if (arrayLength == 2) {
              setbarwidth('30%')
            }  else if (arrayLength == 1) {
              setbarwidth('20%')
            } else {
              setbarwidth('30%')
            }

            // const formatAmount = (amount) => {
            //   return amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
            // };

            // let datta = data['values'];
            // datta.forEach((data) =>{
            //   const formattedAmount = formatAmount(data);
            //   console.log('formattedAmount', formattedAmount);
            // })


          }

        )
        .catch((error) => {
          // setDoughnutData([60,30,150])
          setChartHidden(false);
          console.error("Error in POST request:", error);
        });
    }
  }

  const Fetchbankinfo1 = (label) => {
    let payload = {

      query:`SELECT * FROM account_receivable_1.bank_alert WHERE customer_id = '${selectedOption1.label}' AND status = '${label}';`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          setExtGridData(data)
        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo = (label) => {

    let payload = {
      query:`SELECT * FROM account_receivable_1.invoices WHERE \`Client ID\` = '${selectedOption1.label}' AND status = '${label}';`
    }

    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials)

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];

          setIntGridData(data);
          // setExtGridData(data);
          // setfinalinternaldata(data['ar_model']);
          // setfinalexternaldata(data['ext_bank']);
          // setDoughnutData([]);
          // clickedmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedunmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedallbtn(data['ar_model'], data['ext_bank']);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }


  const ClickAllocateButton = () => {

    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      "intern": openIntGridData,
      "extern": openExtGridData,
      'funding_due_date': selectedDate,
      'client_name': selectedOption.label,
      'client_id': selectedOption1.value
    }

    console.log('payload', payload);
    var getProcessingLayerDataWithStatus = allocateupdatestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          alert('successfully allocated amount')
          // if(selectedLabelnew){
          //   Fetchbankinfo(selectedLabelnew)
          //   handleClose();
          // }
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
          alert('getting error allocating amount')
        }
      );

  }

  const Fetchbankinfo_2 = (label) => {

    let payload = {
      query:`SELECT * FROM account_receivable_1.bank_alert WHERE customer_id is NULL;`

    }

    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];

          // setIntGridData(data);
          setExtGridData(data);
          // setfinalinternaldata(data['ar_model']);
          // setfinalexternaldata(data['ext_bank']);
          // setDoughnutData([]);
          // clickedmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedunmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedallbtn(data['ar_model'], data['ext_bank']);
          console.log('ext fetched')

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }




  const Fetchbankinfo_1 = (label) => {

    let payload = {
      query:`SELECT * FROM account_receivable_1.bank_alert WHERE customer_id = '${selectedOption1.label}';`

    }

    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];

          // setIntGridData(data);
          setExtGridData(data);
          // setfinalinternaldata(data['ar_model']);
          // setfinalexternaldata(data['ext_bank']);
          // setDoughnutData([]);
          // clickedmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedunmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedallbtn(data['ar_model'], data['ext_bank']);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo_ = (label) => {

    let payload = {
      query:`SELECT * FROM account_receivable_1.invoices WHERE \`Client ID\`= '${selectedOption1.label}';`

      
    }
    
    let data1;

    if (label === 'Open') {
      data1 = 'multiple';
    } else {
      data1 = 'single';
    }

    console.log('payload---', payload)
    setisMultiSelect(data1)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials)

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];

          setIntGridData(data);
          // setExtGridData(data);
          // setfinalinternaldata(data['ar_model']);
          // setfinalexternaldata(data['ext_bank']);
          // setDoughnutData([]);
          // clickedmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedunmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedallbtn(data['ar_model'], data['ext_bank']);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  
  const Fetchbankinfo_5 = (label) => {

    let payload = {
      query:`SELECT * FROM account_receivable_1.invoices WHERE \`Client ID\`= '123';`

      
    }
    
    let data1;

    if (label === 'Open') {
      data1 = 'multiple';
    } else {
      data1 = 'single';
    }

    console.log('payload---', payload)
    setisMultiSelect(data1)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials)

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];

          setIntGridData(data);
          // setExtGridData(data);
          // setfinalinternaldata(data['ar_model']);
          // setfinalexternaldata(data['ext_bank']);
          // setDoughnutData([]);
          // clickedmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedunmatchbtn(data['ar_model'], data['ext_bank']);
          // clickedallbtn(data['ar_model'], data['ext_bank']);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const clickedmatchbtn = (internaldata, externaldata) => {
    const filterKey = "Closed";
    const filteredData = internaldata.filter(item => item.status === filterKey);
    const filteredData1 = externaldata.filter(item => item.status === filterKey);
    let length = filteredData.length + filteredData1.length;
    doughnutdata.push(length);

    setDoughnutData(doughnutdata);
    // let matcheddata1 = {
    //   'internal_data': filteredData,
    //   'external_data': filteredData1
    // };
    // setMatchedData(matcheddata1);
    // console.log('filteredData', matcheddata1 );
  }

  const clickedunmatchbtn = (internaldata, externaldata) => {
    const filterKey = "Open";
    const filteredData2 = internaldata.filter(item => item.status === filterKey);
    const filteredData3 = externaldata.filter(item => item.status === filterKey);
    let length = filteredData2.length + filteredData3.length;
    doughnutdata.push(length);
    setDoughnutData(doughnutdata);
    // setunmatcheddata(
    //   {
    //   'internal_data': filteredData2,
    //   'external_data': filteredData3
    //   }
    // )
    // console.log('filteredData1', filteredData2, filteredData3,length);
  }

  const clickedallbtn = (internaldata, externaldata) => {
    let length = internaldata.length + externaldata.length;
    doughnutdata.push(length);
    setDoughnutData(doughnutdata);
    // setalldata(
    //   {
    //   'internal_data': internaldata,
    //   'external_data': externaldata
    //   }
    // )
    // console.log('finalinternaldata', internaldata, externaldata, length);
  }

  useEffect(() => {
    BrsTypeList();
    fetchstatuscolumntypeslist();
  }, []);


  const fetchstatuscolumntypeslist = (label) => {

    let payload = {
      'client_ids': '',
    }

    var FileUploadCredentials = getstatustypeslist();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response fetch status types list data!!!", response);
          let data = response["data"];
          let data1 = ['Open','Closed','Groupmatch','Funding','Credit Note','Debit Note','Dispute'];
          const dropdownOptions = data1.map((item) => ({ value: item, label: item }));
          // const dropdownOptions = data1.map((item) => ({ value: item.name, label: item.name }));
          if (label !== 'Unallocated Credits') {
            setOptionslist(dropdownOptions);
        } else {
            setOptionslist(options);
        }

        }

      )
      .catch((error) => {

        console.error("Error in POST request:", error);
      });

  }



  const fetchdonutchartdata = (event) => {
    if (event) {
      let payload = {
        // 'client_ids': event.label,
        'schema_name': 'account_receivable_1',
        'table1' : 'invoices',
        'table2' : 'bank_alert',
        // 'client_name_1': selectedOption.label,
        // 'Supplier_code_2': selectedOption.label,
        'client_id_1': event.label,
        'customer_id_2': event.label,
        // 'user_id': userCredentials["user_id"],
      }

      console.log('payload123', payload)

      var FileUploadCredentials = updatedonutvalue();


      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
  .then(response => {
      console.log("Response:", response);
      
      let countData = response.data; // Assuming the count data is directly in the response
      // Process the count data as needed
      console.log("Count data:", countData);
      console.log("Groupmatch count:", countData.Groupmatch);
      console.log("Open count:", countData.Open);
      console.log("Contra count:", countData.Contra);
      console.log("Match count:", countData.Match);
      console.log("All count:", countData.All);

      const labels1 = Object.keys(countData);
      console.log("Labels:", labels1);

      // Get values corresponding to the labels
      const values1 = labels1.map(label => countData[label]);
      console.log("Values:", values1);
      const updatedLabels1 = [...labels1];

      // Add value for "unallocated credits" to values array
      const updatedValues1 = [...values1];

      console.log("Validate Credentials Response fetch labels data!!!", countData.keys);
      let label1 = updatedLabels1;
      let series1 = updatedValues1;
      setDoughnutLabel(label1);
      setDoughnutData(series1);
  })
  .catch(error => {
    console.error("Error in POST request:", error);
  });
}};


  function getKpiinfo(event) {

    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'supplier_code':selectedOption.label,
      "client_id": event.label

    }
    console.log('payload status',payload)

    var getProcessingLayerDataWithStatus = getkpidatarecon();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status with chart data----!!!", response)
          let data = response["data"];
          let arrays = data["Overdue"];
          let arrays1 = data["outstanding_value"];

          let arrays2 = data["total"];
          console.log('data123445',data,arrays,arrays1,arrays2)

          let overdue = arrays[0].inv_total;
          let outsatnding = arrays1[0].inv_total;
          let total = arrays2[0].inv_total;
          console.log('overdue', overdue, outsatnding,total,arrays);
          setoverdue(total);
          setoutstanding(overdue);
          settotal(outsatnding);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data with chart data!!!", error);
        }
      );
  }

  const changedropdown1 = (event) => {
    setdropdown1(event)
    console.log('dropselectedOption1',selectedOption1)
    fetchpaymenthistory(selectedOption1.value, event.value)
  }

  const handleSelection1 = (event) => {
    setSelectedOption1(event);
    getKpiinfo(event)
    // fetchdonutchartdata(event);

    fetchmonthwisedata(event);
    fetchdonutchartdata(event)

    fetchpaymenthistory(event.label, 'Day');

  }


  function handleSelection(event) {
    console.log('event', event);
    const selectedValue = event;

    // const selectedOption = options.find(option => option.processing_layer_name === selectedValue); // Find the option with the selected value
    // const layerId = selectedOption ? selectedOption.processing_layer_id : null; 
    // console.log("layerId", layerId);
    setSelectedOption(selectedValue);
    // setLayerId(layerId);
    // getBalances(layerId);
    // processingLayerData(selectedValue, layerId);
    const filterKey = selectedValue.label;

    // Filter the data based on the specified key
    console.log('clientid',clientids,filterKey)
    const filteredData = clientids.filter(item => item.key === filterKey);
    // Create a Set to track unique values
    const uniqueSet = new Set();

    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;

      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }

      return false; // Skip duplicates
    });

    console.log(filteredData1);

    console.log('filteredData', filteredData);
    setclientids1(filteredData1);
    // setUnMatchedHidden(true);
    setOpenGridHidden(true);
    setIntGridData([]);
    setExtGridData([]);
    setChartHidden(true);
    setExternalAmount(0.00);
    setInternalAmount(0.00);
    setMatchHidden(true);
    setDuplicateHidden(true);
    // setUnMatchHidden(true);
    setSearchHidden(true);
    setContraHidden(true);
    setLabel('');

  }

  function BrsTypeList() {
    setLoaderOpen(true);
    let payload = {
      
      query: `SELECT * FROM account_receivable_1.client_master;`
      
    }
    console.log('userCredentials["groups_id"],', userCredentials);
    var getProcessingLayerList = Fetchexecutequery();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let data = response["data"];
          
          console.log('data123', data);
          if (data) {
            //let clientIdsArray = JSON.parse(data[0].client_ids);
    
            // Parse customer_names string into an array
            const customerNamesArray = data.map(item => item.client_id);
            //console.log('clientIdsArray',clientIdsArray)
            console.log('customerNamesArray',customerNamesArray)
            
            // Transform the arrays into the desired format
            const filterUnique = (arr) => {
              let seen = {};
              return arr.filter(item => {
                  return seen.hasOwnProperty(item.key) ? false : (seen[item.key] = true);
              });
          };
      
          // Filter out duplicate items and transform them into the desired format
          const options = customerNamesArray.map(item => ({ label: item, value: item }));
          //let clientIds = clientIdsArray.map(row => ({ label: row.value, value: row.value, key: row.key }));
            //console.log('clientIds',clientIds)
            // setOptions(clientIds);
            // setClientNames(customerNames);
            setOptions(options);
            //setclientids(clientIds);
            
          }
          setLoaderOpen(false);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
          setLoaderOpen(false);
        }
      );

  }

  // function processingLayerData(selectedValue, layerId) {
  //   setIntDebit('');
  //   setIntCredit('');
  //   setExtDebit('');
  //   setExtCredit('');
  //   setAmountTolerance('');
  //   setIntName('');
  //   setExtName('');
  //   setIntDate('');
  //   setExtDate('');
  //   setLoaderOpen(true);
  //   let payload = {
  //     "processing_layer": selectedValue,
  //     "tenants_id": 1,
  //     "groups_id": 1,
  //     "entities_id": 1,
  //     "processing_layer_id": layerId
  //   }

  //   var getProcessingLayerData = getProcessingLayerDataFromServer();
  //   console.log("url", getProcessingLayerData[0])

  //   return axios.post(getProcessingLayerData[1], { params: payload }, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data!!!", response)
  //         let data = response["data"];
  //         if (data["Status"] === "Success") {
  //           console.log("data", data);
  //           setDoughnutLabel(data["Label"]);
  //           setDoughnutData(data["Values"]);
  //           setIntDebit(data["int_dr"]);
  //           setIntCredit(data["int_cr"]);
  //           setExtDebit(data["ext_dr"]);
  //           setExtCredit(data["ext_cr"]);
  //           setAmountTolerance(data["amount_tolerance"]);
  //           setIntName(data["m_source_name_int"]);
  //           setExtName(data["m_source_name_ext"]);
  //           setChartHidden(false);
  //           setUnMatchHidden(true);
  //           setContraHidden(true);
  //           setIntDate(data["int_date"]);
  //           setExtDate(data["ext_date"]);
  //         }
  //         setLoaderOpen(false);
  //         return response;
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //         setLoaderOpen(false);
  //       }
  //     );

  // }

  // function getBalances(layerId) {
  //   setLoaderOpen(true);
  //   let payload = {
  //     "tenantsId": userCredentials["tenants_id"],
  //     "groupsId": userCredentials["groups_id"],
  //     "entityId": userCredentials["entities_id"],
  //     "mProcessingLayerId": userCredentials["m_processing_layer_id"],
  //     "mProcessingSubLayerId": userCredentials["m_processing_sub_layer_id"],
  //     "processingLayerId": layerId
  //   }

  //   var getBalance = getBalanceFromServer();

  //   axios.post(getBalance[1], { params: payload }, getBalance[0])
  //     .then(
  //       response => {
  //         console.log("Get Balance Response!!!", response)
  //         let data = response["data"];
  //         if (data["Status"] === "Success") {
  //           console.log("bal", data["data"]["bank_balance"])
  //           setBankBalance(data["data"]["bank_balance"]);
  //           setErpBalance(data["data"]["gl_balance"]);
  //           // setLoaderOpen(false);
  //         }
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Get Balance!!!", error);
  //         // setLoaderOpen(false);
  //       }
  //     );

  // }

  // function processingLayerDataReturn() {
  //   let payload = {
  //     "int_name": intName,
  //     "ext_name": extName,
  //   }

  //   var getProcessingLayerData = getProcessingLayerDataReturnFromServer();
  //   console.log("url", getProcessingLayerData[0])

  //   return axios.post(getProcessingLayerData[1], { params: payload }, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data!!!", response)
  //         let data = response["data"];
  //         if (data["Status"] === "Success") {
  //           console.log("data", data);
  //           setDoughnutLabel(data["Label"]);
  //           setDoughnutData(data["Values"]);
  //           setChartHidden(false);
  //           setUnMatchHidden(true);
  //           setContraHidden(true);
  //         }
  //         return response;
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );

  // }

  // const handleDataPointSelection1 = (event, chartContext, config) => {
    
  //   const selectedLabel = config.w.config.labels[config.dataPointIndex];
  //   console.log("selectedLabel", selectedLabel);
  //   console.log("intNameClicked", intName);
  //   setLabel(selectedLabel);
  //   // getChartClickedData(selectedLabel);
  //   setOpenIntGridData([]);
  //   setOpenExtGridData([]);
  //   setExternalAmount(0.00);
  //   setInternalAmount(0.00);
  //   setMatchHidden(true);
  //   setDuplicateHidden(true);
  //   setUnMatchHidden(true);
  //   setContraHidden(true);
  // };

  // const handleLegendClick = () => {
  //   setChartData((prevChartData) => ({
  //     ...prevChartData,
  //     options: {
  //       ...prevChartData.options,
  //       dataLabels: {
  //         enabled: !prevChartData.options.dataLabels.enabled,
  //       },
  //     },
  //   }));
  // };

  // const [chartData, setChartData] = useState({
  //   series: doughnutdata,
  //   options: {
  //     labels: doughnutLabel,
  //     colors: ["#66cc66", "#ff4d4d", "#1a75ff", "#b84dff", "#ff944d", "#00cccc"],
  //     legend: {
  //       onItemClick: {
  //         toggleDataSeries: false,
  //         onClick: handleLegendClick,
  //       },
  //     },
  //     chart: {
  //       width: 380,
  //       type: "donut",
  //     },
  //     plotOptions: {
  //       pie: {
  //         startAngle: -90,
  //         endAngle: 270,
  //       },
  //     },
  //     dataLabels: {
  //       enabled: true, // Show labels by default
  //     },
  //     fill: {
  //       type: "gradient",
  //     },
  //     title: {
  //       text: "",
  //     },
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         options: {
  //           chart: {
  //             width: 200,
  //           },
  //           legend: {
  //             position: "bottom",
  //           },
  //         },
  //       },
  //     ],
  //   },
  // });



  // const chartData = {
  //   series: doughnutdata,
  //   options: {
  //     labels: doughnutLabel,
  //     colors: ['#66cc66', '#ff4d4d', '#1a75ff', '#b84dff', '#ff944d', '#00cccc'],
  //     legend: {
  //       onItemClick: {
  //         toggleDataSeries: false,
  //       }
  //     },
  //     chart: {
  //       width: 250,
  //       type: 'donut'
  //     },
  //     plotOptions: {
  //       pie: {
  //         startAngle: -90,
  //         endAngle: 270
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false
  //     },
  //     fill: {
  //       type: 'gradient',
  //     },
  //     // legend: doughnutLabel,
  //     title: {
  //       text: '123'
  //     },

  //     responsive: [{
  //       breakpoint: 480,
  //       options: {
  //         chart: {
  //           width: 200
  //         },
  //         legend: {
  //           position: 'bottom'
  //         }
  //       }
  //     }],
  //     chart: {
  //       events: {
  //         dataPointSelection: handleDataPointSelection
  //       }
  //     }
  //   },
  // };

  // useEffect(() => {
  //   // setUnMatchedHidden(true);
  //   // setOpenGridHidden(true);
  //   // setMatchHidden(true);
  //   // setDuplicateHidden(true);
  //   // setUnMatchHidden(true);
  //   setSearchHidden(true);
  //   // setSelectedId(null);
  //   // setContraHidden(true);
  //   if (label) {
  //     setLoaderOpen(true); // Show loader while the API call is in progress
  //     getChartClickedData(label);
  //   }
  // }, [intName, extName, label]);
  // useEffect(() => {
  //   setUnMatchedHidden(true);
  //   setOpenGridHidden(true);
  //   setMatchHidden(true);
  //   setDuplicateHidden(true);
  //   setUnMatchHidden(true);
  //   setSelectedId(null);
  //   setContraHidden(true);
  //   getChartClickedData(label);

  // }, [intName, extName, label]);

  // const getChartClickedData = async (selectedLabel) => {
  //   try {
  //     console.log("intNameinside", intName);
  //     setLoaderOpen(true); // Use the passed setLoaderOpen function
  //     let payload = {
  //       "status": selectedLabel,
  //       "int_name": intName,
  //       "ext_name": extName,
  //     }

  //     var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

  //     const response = await axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0]);
  //     console.log("Processing Layer Data With Status!!!", response);
  //     let data = response["data"];
  //     if (data["Status"] === "Success") {
  //       console.log("data", data);
  //       setIntGridData(data["internal_data"]);
  //       setExtGridData(data["external_data"]);
  //       setUnMatchedHidden(false);
  //       setSearchHidden(false);
  //       setOpenGridHidden(true);
  //       setMatchHidden(true);
  //       setDuplicateHidden(true);
  //       setUnMatchHidden(true);
  //       setSelectedId(null);
  //       setContraHidden(true);
  //     }
  //     setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state

  //     return response;
  //   } catch (error) {
  //     console.log("Error in Processing Layer Data With Status!!!", error);
  //     setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state
  //   }
  // };


  // const getChartClickedData = async (selectedLabel) => {
  //   try {
  //     console.log("intNameinside", intName);
  //     setLoaderOpen(true); // Use the passed setLoaderOpen function
  //     let payload = {
  //       "status": selectedLabel,
  //       "int_name": intName,
  //       "ext_name": extName,
  //     }

  //     var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

  //     const response = await axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0]);
  //     console.log("Processing Layer Data With Status!!!", response);
  //     let data = response["data"];
  //     if (data["Status"] === "Success") {
  //       console.log("data", data);
  //       setIntGridData(data["internal_data"]);
  //       setExtGridData(data["external_data"]);
  //       setUnMatchedHidden(false);
  //       setOpenGridHidden(true);
  //       setMatchHidden(true);
  //       setDuplicateHidden(true);
  //       setUnMatchHidden(true);
  //       setSelectedId(null);
  //       setContraHidden(true);
  //     }
  //     setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state

  //     return response;
  //   } catch (error) {
  //     console.log("Error in Processing Layer Data With Status!!!", error);
  //     setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state
  //   }
  // };


  // function getChartClickedData(selectedLabel)
  // {
  //     console.log("intNameChart", intName);
  //     setLoaderOpen(true);
  //     let payload = {
  //       "status": selectedLabel,
  //       "int_name" : intName,
  //       "ext_name" : extName,
  //     }

  //     var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

  //     return axios.post(getProcessingLayerDataWithStatus[1], {params : payload}, getProcessingLayerDataWithStatus[0])
  //     .then(
  //         response => {
  //             console.log("Processing Layer Data With Status!!!", response)
  //             let data = response["data"];
  //             if (data["Status"] === "Success") {
  //               console.log("data", data);
  //               setIntGridData(data["internal_data"]);
  //               setExtGridData(data["external_data"]);
  //               setUnMatchedHidden(false);
  //               setOpenGridHidden(true);
  //               setMatchHidden(true);
  //               setDuplicateHidden(true);
  //               setUnMatchHidden(true);
  //               setSelectedId(null);
  //               setContraHidden(true);
  //             }
  //             setLoaderOpen(false);
  //             return response;
  //         }
  //     ).catch(
  //         error => {
  //             console.log("Error in Processing Layer Data WIth Status!!!", error);
  //             setLoaderOpen(false);
  //         }
  //     );

  // }

  // function getChartClickedDataReturn(selectedLabel) {
  //   let payload = {
  //     "status": selectedLabel,
  //     "int_name": intName,
  //     "ext_name": extName,
  //   }

  //   var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

  //   return axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data With Status!!!", response)
  //         let data = response["data"];
  //         if (data["Status"] === "Success") {
  //           console.log("data", data);
  //           setIntGridData(data["internal_data"]);
  //           setExtGridData(data["external_data"]);
  //           setUnMatchedHidden(false);
  //           setSearchHidden(false);
  //           setOpenGridHidden(true);
  //           setMatchHidden(true);
  //           setDuplicateHidden(true);
  //           setUnMatchHidden(true);
  //           setSelectedId(null);
  //           setContraHidden(true);
  //         }
  //         return response;
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data WIth Status!!!", error);
  //       }
  //     );

  // }

  // const intColumnDefs = React.useMemo(() => {
  //   if (intGridData.length > 0) {
  //     // Get the column names from the first row of the JSON data
  //     const keys = Object.keys(intGridData[0]);

  //     // Create column definitions with the checkbox as the first column
  //     const intColumnDefs = [
  //       {
  //         headerName: '',
  //         checkboxSelection: true,
  //         width: 50,
  //       },
  //       ...keys
  //       .filter((key) => key !== 'id') // Filter out the "id" column
  //       .map((key) => {
  //         // Calculate the maximum content width for the current column
  //         const maxWidth = intGridData.reduce(
  //           (max, data) => {
  //             const cellContent = data[key] ? data[key].toString() : '';
  //             return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
  //           },
  //           100 // Set a minimum width of 100 to avoid very narrow columns
  //         );

  //         return {
  //           headerName: key,
  //           field: key.replace(/\./g, '[""]'),
  //           sortable: true, 
  //           filter: true, 
  //           resizable: true,
  //           width: maxWidth,
  //         };
  //       }),
  //   ];

  //     return intColumnDefs;
  //   }
  //   return [];
  // }, [intGridData]);

  const intColumnDefs = React.useMemo(() => {
    if (intGridData && intGridData.length > 0) {
      const keys = Object.keys(intGridData[0]);

      const dynamicColumnDefs = [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 50,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelectionMultiple: false,
        },
        ...keys
          .filter((key) => key !== 'id')
          .map((key) => {
            // Column definition setup
            const maxWidth = intGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );
            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
              editable: true,
              cellEditor: 'agTextCellEditor',
            };
          }),
      ];

      return dynamicColumnDefs;
    }
    return [];
  }, [intGridData]);

  let gridApi;
  let gridApiInt;

  const extColumnDefs = React.useMemo(() => {
    if (extGridData && extGridData.length > 0) {
      const keys = Object.keys(extGridData[0]);

      const dynamicColumnDefs = [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 50,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelectionMultiple: false,
        },
        ...keys
          .filter((key) => key !== 'id')
          .map((key) => {
            // Column definition setup
            const maxWidth = extGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );
            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
              editable: true,
              cellEditor: 'agTextCellEditor',
            };
          }),
      ];

      return dynamicColumnDefs;
    }
    return [];
  }, [extGridData]);

  const onGridReady = (params) => {
    const { api } = params;
    gridApi = api;
  };


  // const extColumnDefs = React.useMemo(() => {
  //   if (extGridData.length > 0) {
  //     // Get the column names from the first row of the JSON data
  //     const keys = Object.keys(extGridData[0]);

  //     // Create column definitions with the checkbox as the first column
  //     const extColumnDefs = [ 
  //       {
  //         headerName: '',
  //         checkboxSelection: true,
  //         width: 50,
  //       },
  //       ...keys
  //       .filter((key) => key !== 'id') // Filter out the "id" column
  //       .map((key) => {
  //         // Calculate the maximum content width for the current column
  //         const maxWidth = extGridData.reduce(
  //           (max, data) => {
  //             const cellContent = data[key] ? data[key].toString() : '';
  //             return Math.max(max, cellContent.length * 10); // Adjust the constant factor (10) as needed
  //           },
  //           100 // Set a minimum width of 100 to avoid very narrow columns
  //         );

  //         return {
  //           headerName: key,
  //           field: key.replace(/\./g, '[""]'),
  //           sortable: true, 
  //           filter: true, 
  //           resizable: true,
  //           width: maxWidth,
  //         };
  //       }),
  //   ];

  //     return extColumnDefs;
  //   }
  //   return [];
  // }, [extGridData]);


    const Readunreadmails = () => {
      setLoaderOpen(true);
      console.log('clicked read button');
      let payload = {
          id: '123'
      }

      var FileUploadCredentials = Readmails();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
          .then(
              response => {
                  console.log("create excel file", response);
                  alert('successfully Read mails')
                  setLoaderOpen(false);
              }
          ).catch(
              error => {
                  console.log("Error in reading mails!!!", error);
                  alert('Error in created target config file')
                  setLoaderOpen(false);
              }
          );
  }


  const OpenExtColumnDefs = React.useMemo(() => {
    if (openExtGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openExtGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 120
        })),
      ];
      // setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [openExtGridData]);


  // const OpenIntColumnDefs = React.useMemo(() => {
  //   if (openExtGridData?.length > 0) {
  //     // Get the column names from the first row of the JSON data
  //     const keys = Object.keys(openExtGridData[0]);

  //     // Create column definitions with the checkbox as the first column
  //     const intColumnDefs1 = [
  //       {
  //         headerCheckboxSelection: true, // Add this line for the checkbox selection
  //         checkboxSelection: true, // Add this line for the checkbox selection
  //         width: 20
  //       },
  //       ...keys.map((key) => ({
  //         headerName: key,
  //         field: key,
  //         sortable: true,
  //         filter: true,
  //         resizable: true
  //       })),
  //     ];
  //     setbankcolumnnames(intColumnDefs1);
  //     console.log('intColumnDefs', intColumnDefs1);
  //     return intColumnDefs1;
  //   }
  //   return [];
  // }, [openExtGridData]);



  const OpenIntColumnDefs = React.useMemo(() => {
    if (openIntGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openIntGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 120
        })),
      ];
      // setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [openIntGridData]);


  // const getmatchedidrecords = (matchid, isint_ext) => {
  //   console.log('123467',matchid, isint_ext)
    
  //   let payload = {
  //     "match_id": matchid,

  //   }

  //   var getProcessingLayerData = Fetchbankinvoicedetails1();
  //   console.log("url---", getProcessingLayerData[0], matchid)

  //   return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data 123!!!", response)
  //         let data = response["data"];

  //         setOpenIntGridData(data)

  //         // setOpenExtGridData((prevData) => [
  //         //   ...prevData,
  //         //   ...data['ext_bank']]);
  //       //   setOpenIntGridData((prevData) => [
  //       //     ...prevData,
  //       //     ...data['ar_model']]);
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );

  //     var getProcessingLayerData = Fetchexternaldetails();
  //   console.log("url---", getProcessingLayerData[0], matchid)

  //   return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data 123!!!", response)
  //         let data = response["data"];

  //         setOpenIntGridData(data)

  //         // setOpenExtGridData((prevData) => [
  //         //   ...prevData,
  //         //   ...data['ext_bank']]);
  //       //   setOpenIntGridData((prevData) => [
  //       //     ...prevData,
  //       //     ...data['ar_model']]);
  //       }
  //     ).catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );

  // }

  // const getmatchedidrecords = (matchid, isint_ext) => {
  //   console.log('123467', matchid, isint_ext)
  
  //   let payload = {
  //     "match_id": matchid,
  //   };
  
  //   var getProcessingLayerData = Fetchbankinvoicedetails12();
  //   console.log("url---", getProcessingLayerData[0], matchid);
  
  //   axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data 123!!!", response);
  //         let data = response["data"];
  //         setOpenIntGridData(data);
  //       }
  //     )
  //     .catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );
        
  //   var getProcessingLayerDataExternal = Fetchexternaldetails1();
  //   console.log("url---", getProcessingLayerDataExternal[0], matchid);
  
  //   axios.post(getProcessingLayerDataExternal[1], payload, getProcessingLayerDataExternal[0])
  //     .then(
  //       response => {
  //         console.log("Processing Layer Data 123!!!", response);
  //         let data = response["data"];
  
  //         setOpenExtGridData(data);
  
  //         // setOpenExtGridData((prevData) => [
  //         //   ...prevData,
  //         //   ...data['ext_bank']]);
  //         //   setOpenIntGridData((prevData) => [
  //         //     ...prevData,
  //         //     ...data['ar_model']]);
  //       }
  //     )
  //     .catch(
  //       error => {
  //         console.log("Error in Processing Layer Data!!!", error);
  //       }
  //     );
  // };

  const getmatchedidrecords = (matchid, isint_ext) => {
    console.log('123467', matchid, isint_ext)
  
    let payloadInt = {
      query :  `SELECT * FROM account_receivable_1.invoices WHERE match_id = '${matchid}' ;`
    };
  
    var getProcessingLayerData = Fetchexecutequery();
    console.log("url---", getProcessingLayerData[0], matchid);
  
    axios.post(getProcessingLayerData[1], payloadInt, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data 123!!!", response);
          let data = response["data"];
          setOpenIntGridData(data);
        }
      )
      .catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
        
    let payloadExt = {
      query :  `SELECT * FROM account_receivable_1.bank_alert WHERE match_id IN ('${matchid}');`
    };
    var getProcessingLayerDataExternal = Fetchexecutequery();
    console.log("url---", getProcessingLayerDataExternal[0], matchid);
  
    axios.post(getProcessingLayerDataExternal[1], payloadExt, getProcessingLayerDataExternal[0])
      .then(
        response => {
          console.log("Processing Layer Data 123!!!", response);
          let data = response["data"];
  
          setOpenExtGridData(data);
  
          // setOpenExtGridData((prevData) => [
          //   ...prevData,
          //   ...data['ext_bank']]);
          //   setOpenIntGridData((prevData) => [
          //     ...prevData,
          //     ...data['ar_model']]);
        }
      )
      .catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  };
  
  
  const remarkscolumnnames = React.useMemo(() => {
    let keys = [];
    // Check if remarksdata is an array and has at least two elements
    console.log('remarksdata',remarksdata)
    if (Array.isArray(remarksdata) && remarksdata.length > 0) {
      // Iterate over each record in remarksdata
      remarksdata.forEach((record) => {
          // Extract the JSON string from the remarks property of the record
          const jsonRemarks = record.remarks;
          // Parse the JSON string into an array
          const remarksArray = JSON.parse(jsonRemarks);
          // Check if the parsed array contains at least one element and is an array of objects
          if (Array.isArray(remarksArray) && remarksArray.length > 0) {
              // Iterate over each object in the parsed array
              remarksArray.forEach((obj) => {
                  // Check if the object is not empty
                  if (Object.keys(obj).length > 0) {
                      // Collect unique keys from the non-empty object
                      Object.keys(obj).forEach((key) => {
                          if (!keys.includes(key)) {
                              keys.push(key);
                          }
                      });
                  }
              });
          }
      });
  }


    
    // Create column definitions with the extracted keys
    const intColumnRemarks = keys.map((key) => ({
        headerName: key,
        field: key,
        sortable: true,
        filter: true,
        resizable: true,
        width: 100
    }));
    setremarkscol(intColumnRemarks);

    // Create an array to hold the data for each row
    const rowData = [];

    // Iterate over each record in remarksdata
    remarksdata.forEach((record) => {
        // Extract the JSON string from the remarks property of the record
        const jsonRemarks = record.remarks;
        console.log('jsonRemarks',jsonRemarks)
        // Parse the JSON string into an array
        const remarksArray = JSON.parse(jsonRemarks);
        // Iterate over each object in the parsed array
        remarksArray.forEach((obj) => {
            // Create an object to hold the data for the current row
            const rowDataItem = {};
            // Iterate over each key in the keys array
            keys.forEach((key) => {
                // Check if the current object has the key
                if (obj.hasOwnProperty(key)) {
                    // Add the value for the current key to the rowDataItem object
                    rowDataItem[key] = obj[key];
                } else {
                    // If the current object doesn't have the key, set its value to null
                    rowDataItem[key] = null;
                }
            });
            console.log('1234row',rowDataItem,intColumnRemarks)
            // Add the rowDataItem object to the rowData array
            rowData.push(rowDataItem);
        });
    });
    console.log('rowData',rowData)
    setmodelnames1(rowData)

    // Return the column definitions and the data for the table
    return { columns: intColumnRemarks, rowData };
    // return intColumnRemarks;
}, [remarksdata]);




  const fetchremarksinfo = (id) => {
    let payload = {
      query : `Select remarks from  account_receivable_1.invoices where primary_id = '${id}';`,
    }

    var getProcessingLayerData = Fetchexecutequery();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data1);
          setremarksdata(data);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );

  }

  const fetchremarksinfo1 = (id) => {
    let payload = {
      "primary_id": id,
    }

    var getProcessingLayerData = Fetchbankinvoicedetails();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data1);
          setremarksdata1(data1);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );

  }


  const handleClose = () => {
    // setFormValues({ id: "", client_id: "", client_name: "", email_address: "" });
    // setShow(false);
    // setShow1(false);
    console.log('called');
    setShow3(false);
    setOpenExtGridData([]);
    setOpenIntGridData([]);
    setcustomer_advice_location('');
    setmodelcolumnnames1([]);
    setmodelcolumnnames([]);

    setDuplicateHidden(true);
    setShow5(false);
    setShow6(false);
    setremarkscol([]);
    setremarksdata([]);
    setremarkscol1([]);
    setremarksdata1([]);
    setInternalAmount(0.00);
    setExternalAmount(0.00);

    if (agIntGridRef.current) {
      const api = agIntGridRef.current.api;
      api.deselectAll(); // This deselects all currently selected rows
    }

    if (agExtGridRef.current) {
      const api1 = agExtGridRef.current.api;
      api1.deselectAll(); // This deselects all currently selected rows
    }

    setOpenGridHidden(true);

  };

  const [intmatchid, setintmatchid] = useState([])
  const [extmatchid, setextmatchid] = useState([])

  const handleCheckboxChangeInt = (event) => {
    const selectedRow = event.api.getSelectedRows();
    console.log("internal selected checkbox row", selectedRow);

    // if (selectedRow && selectedRow.length > 0) {
    //   status1 = String(selectedRow[0]['status']);
    //   if (status1 === 'Closed') {
    //     if(intmatchid.length > 1 || extmatchid.length > 1){
    //       return
    //     }
    //   }
    // }

    const lastDictionary = selectedRow[selectedRow.length - 1];

    setOpenGridHidden(true);
    setDuplicateHidden(true);
    let matchid = '';
    let match_ids_list = '';
    let status1 = '';
    if (selectedRow && selectedRow.length > 0) {
      let data = selectedRow[0]['primary_id'];
      match_ids_list = selectedRow[0]['match_id']
      // let match_ids_array = Array.isArray(match_ids_list) ? match_ids_list : JSON.parse(match_ids_list);
      // matchid = match_ids_array.join(', ');.
      matchid = match_ids_list

      status1 = String(selectedRow[0]['status']);
      console.log('dataset',data, matchid, extGridData);
      setismatched({ value: "Closed", label: "Closed" });
      let intern_stmnt_id = String(selectedRow[0]['primary_id']);
      fetchremarksinfo(intern_stmnt_id);
      
      setOpenGridHidden(false);
      setChartHidden(true);
    } else {
      console.log('else')

      setmodelcolumnnames1([]);
      setmodelcolumnnames([]);
      setintmatchid([]);
      handleClose();
      setChartHidden(false);
    }

    
  
    const filteredData = extGridData.filter(item => item.match_id === parseInt(matchid));
    console.log('filteredData----', filteredData);
    if (filteredData && filteredData.length > 0) {
    }
    if (status1 === 'Open') {
      setismatched({ value: "Open", label: "Open" });
      setOpenIntGridData(selectedRow);
      // setOpenIntGridData((prevSelectedRow) => ([
      //   ...prevSelectedRow, // Preserve the previous state
      //   ...selectedRow,  // Update with the new value
      // ]));
    }

    else if (selectedRow && selectedRow.length > 0) {
      // setintmatchid((prevCount) =>[
      //   ...prevCount,
      //   matchid
      // ]);
      setintmatchid(matchid)
      if (intmatchid && intmatchid.indexOf(matchid) !== -1) {
        console.log('if')
      
      }else{
        console.log('else');
        status1 = String(selectedRow[0]['status']);
       if (status1 === 'Closed') {
        setOpenExtGridData([]);
        setOpenIntGridData([]);
        // setInternalAmount(0.00);
        // setExternalAmount(0.00);
       }
       console.log('beforematch',matchid)
      getmatchedidrecords(matchid, 'intern');
      getgridClickedDataReturn(matchid);
      }
    }



  };

  const onGridReadyInt = (params) => {
    const { api } = params;
    gridApiInt = api;
  };

  const showmodel = () => {
    setShow3(true);
  }


  const showmodelremarks = () => {
    setShow5(true);
  }

  const ClickView = () => {
    setOpenGridHidden(false);
    setDuplicateHidden(false);
  }

  const handleCheckboxChangeExt = (event) => {
    const selectedRow = event.api.getSelectedRows();
    console.log("external selected checkbox row", selectedRow);
    const lastDictionary = selectedRow[selectedRow.length - 1];

    setOpenGridHidden(true);
    setDuplicateHidden(true);
    let matchid = '';
    let status1 = '';
    if (selectedRow && selectedRow.length > 0) {
      let data = selectedRow[0]['id'];
      matchid = String(selectedRow[0]['match_id']);
      status1 = String(selectedRow[0]['status']);
      console.log(data, matchid, extGridData);
      setismatched({ value: "Closed", label: "Closed" });
      let extern_stmnt_id = String(selectedRow[0]['id']);
      console.log('extern_stmnt_id',extern_stmnt_id)
      fetchremarksinfo1(extern_stmnt_id);
      setOpenGridHidden(false);
      setChartHidden(true);
    } else {
      console.log('else')

      setmodelcolumnnames1([]);
      setmodelcolumnnames([]);
      setintmatchid([]);
      handleClose();
      setChartHidden(false);
    }

    const filteredData = intGridData.filter(item => item.match_id === parseInt(matchid));
    console.log('filteredData----', filteredData);
    if (filteredData && filteredData.length > 0) {
    }
    if (status1 === 'Open') {
      setismatched({ value: "Open", label: "Open" });
      setOpenExtGridData(selectedRow);
      // setOpenIntGridData((prevSelectedRow) => ([
      //   ...prevSelectedRow, // Preserve the previous state
      //   ...selectedRow,  // Update with the new value
      // ]));
    }

    else if (selectedRow && selectedRow.length > 0) {
      // setintmatchid((prevCount) =>[
      //   ...prevCount,
      //   matchid
      // ]);
      setextmatchid(matchid)
      if (intmatchid && intmatchid.indexOf(matchid) !== -1) {
        console.log('if')
      
      }else{
        console.log('else');
        status1 = String(selectedRow[0]['status']);
       if (status1 === 'Closed') {
        setOpenExtGridData([]);
        setOpenIntGridData([]);
        setInternalAmount(0.00);
        setExternalAmount(0.00);
       }
      getmatchedidrecords(matchid, 'intern');
      getgridClickedDataReturn(matchid);
      }
    }
  };


  const formatCurrency = (value) => {
    return value.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    });
  };

  const OpenExtColumnDefs1 = React.useMemo(() => {
    if (openExtGridData.length > 0) {
      console.log("openExtGridData", openExtGridData);
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openExtGridData[0]);

      // Create column definitions with the checkbox as the first column
      const OpenExtColumnDefs = [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 50,
        // },
        ...keys
          .filter((key) => key !== 'id') // Filter out the "id" column
          .map((key) => {
            // Calculate the maximum content width for the current column
            const maxWidth = openExtGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );

            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
            };
          }),
      ];

      return OpenExtColumnDefs;
    }
    return [];
  }, [openExtGridData]);

  const OpenIntColumnDefs9 = React.useMemo(() => {
    if (openIntGridData.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openIntGridData[0]);

      // Create column definitions with the checkbox as the first column
      const OpenIntColumnDefs = [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 50,
        // },
        ...keys
          .filter((key) => key !== 'id') // Filter out the "id" column
          .map((key) => {
            // Calculate the maximum content width for the current column
            const maxWidth = openIntGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );

            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
            };
          }),
      ];

      return OpenIntColumnDefs;
    }
    return [];
  }, [openIntGridData]);


  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  function getExceptiontypedata1(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'exception': exception,
      'client_id': selectedOption1.value

    }

    var getProcessingLayerDataWithStatus = getdataforcardsrecon();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setremarksdata(data1);
          setShow5(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const getFirstcarddata = () => {
    getExceptiontypedata1('Total')
  }

  const getFirstcarddata1 = () => {
    getExceptiontypedata1('Outstanding')
  }

  const getFirstcarddata2 = () => {
    getExceptiontypedata1('Over due')
  }
  

  return (
    
    <div>
      <Grid columns='equal' divided style={{ paddingLeft: "10px", borderRadius: "15px", margin: '0em', marginTop: '-3.3em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column >

            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Customer Name</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={options}
                  selection
                  size='mini'
                  onChange={handleSelection1}
                  value={selectedOption1}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
            </div>

          </Grid.Column>

          <Grid.Column style={{ border: '1px solid #111111', marginRight: '10px', background: 'white', height: '100px', borderRadius: '10px' }} onClick={getFirstcarddata}>
  
          <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em', height: '85px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Card.Content style={{ width: '100%', textAlign: 'center' }}>
              <Card.Header style={{ fontSize: '18px', color: 'white'}}>Total</Card.Header>
              <Divider style={{ background: 'white', height: '1px', width: '60%', margin: '0.3em auto' }} />
              <Card.Description style={{ fontSize: '2rem', fontWeight: '700', color: 'white',marginTop: '.43em'  }}>
                {total} <span style={{ fontSize: '1.2rem' }}>L</span>
              </Card.Description>
            </Card.Content>
          </Card>

        </Grid.Column>
        <Grid.Column style={{ border: '1px solid #111111', marginRight: '10px', background: 'white', height: '100px', borderRadius: '10px' }} onClick={getFirstcarddata1}>

          <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em', height: '85px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Card.Content style={{ width: '100%', textAlign: 'center' }}>
              <Card.Header style={{ fontSize: '18px', color: 'white'}}>Outstanding</Card.Header>
              <Divider style={{ background: 'white', height: '1px', width: '60%', margin: '0.3em auto' }} />
              <Card.Description style={{ fontSize: '2rem', fontWeight: '700', color: 'white',marginTop: '.43em'  }}>
                {outstanding} <span style={{ fontSize: '1.2rem' }}>L</span>
              </Card.Description>
            </Card.Content>
          </Card>

        </Grid.Column>
        <Grid.Column style={{ border: '1px solid #111111', marginRight: '10px', background: 'white', height: '100px', borderRadius: '10px' }} onClick={getFirstcarddata1}>

        <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em', height: '85px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Card.Content style={{ width: '100%', textAlign: 'center' }}>
            <Card.Header style={{ fontSize: '18px', color: 'white'}}>Overdue</Card.Header>
            <Divider style={{ background: 'white', height: '1px', width: '60%', margin: '0.3em auto' }} />
            <Card.Description style={{ fontSize: '2rem', fontWeight: '700', color: 'white',marginTop: '.43em'  }}>
              {overdue} <span style={{ fontSize: '1.2rem' }}>L</span>
            </Card.Description>
          </Card.Content>
        </Card>

        </Grid.Column>
        </Grid.Row>
      </Grid>

     
<Grid columns='equal' divided hidden={chartHidden}>
        <Grid.Row style={{ margin: '1.4em', marginTop: '-2.3em', marginBottom:'0px' }}>
          <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', backgroundColor: 'white', height: '190px' }} hidden={chartHidden}>

            <DynamicDonutChart options={chartData1.labels} series={chartData1.series} onClick={handleChartClick} />
          </Grid.Column>
          <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', padding: '10px', backgroundColor: 'white',height:'190px' }} hidden={chartHidden}><BarChart /></Grid.Column>
          <Grid.Column style={{ borderRadius: '10px', border: '1px solid #111111', backgroundColor: 'white',height:'190px' }} hidden={chartHidden}>
            <div className="row"style={{ height:'40px' }}>
              <div className="col-md-6" style={{ paddingTop: '10px' }}>
                <Select
                  clearable
                  options={payment_history_dropdowns}
                  selection
                  size='mini'
                  onChange={changedropdown1}
                  value={dropdown1}
                  className="custom-dropdown"

                />
              </div>
              {/* <div className="col-md-5">
                <Select
                  clearable
                  options={payment_history_dropdowns1}
                  selection
                  size='mini'
                  onChange={changedropdown2}
                  value={dropdown2}

                />
              </div> */}

            </div>

            <BarChart1 />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <div hidden={openGridHidden}>
        <div className="row">
          <div className="col-md-2 mb-3 mr-3 " style={{marginLeft:'1em'}}>
            <Select
              clearable
              options={optionslist}
              selection
              size='mini'
              onChange={handleSelectionmatched}
              value={ismatched}

            />
          </div>
          {
            selectedval == 'Funding' ? (
              <>
                <div className="col-md-2">
                  <Input type='date' value={selectedDate} onChange={handleDateChange} />
                </div></>) : (<></>)
          }

          <div className="col-md-2">
            <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={ClickSaveButton}>Save</button>
          </div>

          <div className="col-md-2">
            <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={ClickassignButton}>Assign</button>
          </div>
        </div>


<div>
  <Grid>
  <Grid.Row>
    <Grid.Column>
          <div className="ag-theme-alpine" style={{ height: '200px',width: 'calc(100% - 16px)', margin: '0 16px' }}>
          <h4 style={{ margin: 0 }} className="heading">Payments : Rs. {externalAmount}</h4>
                <AgGridReact columnDefs={bankcolumnnames} rowData={openExtGridData} animateRows={true}
                  // rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={12}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true} 
                  rowHeight={30}/>
          </div>
    </Grid.Column>
    </Grid.Row>
    <Grid.Row>
    <Grid.Column>
          <div className="ag-theme-alpine" style={{ height: '200px',width: 'calc(100% - 16px)', margin: '0 16px' }}>
          <h4 className="heading" style={{ margin: '0' }}>Invoices : Rs.  {internalAmount}</h4>
                <AgGridReact columnDefs={arcolumnnames} rowData={openIntGridData} animateRows={true}
                  // rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={12}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true}
                  rowHeight={30} />

          </div>
          </Grid.Column>
  </Grid.Row>
  </Grid>
        </div>

      </div>




 
      <div hidden={unMatchedHidden} style={{ paddingTop: '1.2em' }}>
        <div className="row">
          <div className="col-md-7">
            <div className="search-input-container" style={{ marginTop: '-0.5em' }}>
              <i className="fa fa-search search-icon"></i>
              <input className="search-input" type="text" placeholder="Search..." value={searchText} onChange={onFilterTextChange} style={{ width: '30%' }} />
            </div>

          </div>

          <div className="col-md-4" style={{ marginBottom: "1%", display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
            <div style={{ marginLeft: "auto" }}>
              <a href={bank_advice_location} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFilePdf} style={{ height: '25px', color: "#06054a" }}  />
              </a>
            </div>
            <div style={{ marginLeft: "3%" }}>
              <a href={customer_advice_location} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFileLines} style={{ height: '25px', color: "#06054a" }} />
              </a>
            </div>
            <div style={{ marginLeft: "3%" }}>
              <a onClick={showmodel}>
                <FontAwesomeIcon icon={faEye} style={{ height: '25px', color: "#06054a" }} />
              </a>
            </div>
            <div style={{ marginLeft: "3%" }}>
              <a onClick={showmodelremarks}>
                <FontAwesomeIcon icon={faStreetView} style={{ height: '25px', color: "#06054a" }} />
              </a>
            </div>
            <div style={{ marginLeft: "3%" }}> 
             <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={ClickAllocateButton}>Allocate</button>
            </div>
            <div style={{ marginLeft: "3%" }}> 
             <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={Readunreadmails}>Read Mails</button>
            </div>

          </div>
        </div>
        <div className="grid-container2">
          <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', marginLeft: '7px' }}>
            <h3 className="heading">Payments</h3>
            <AgGridReact columnDefs={bankcolumnnames} rowData={extGridData} animateRows={true}
              ref={agExtGridRef}
              // rowSelection={selectCheckBox}
              rowSelection={isMultiSelect ? 'multiple' : 'single'}
              pagination={true}
              paginationPageSize={12}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              onRowSelected={handleCheckboxChangeExt}
              // suppressRowClickSelection={false}
              quickFilterText={searchText}
              enableRangeSelection={true}
              enableRangeCopy={true}
              onGridReady={onGridReady} 
              rowHeight={30}/>
          </div>
          <div className="ag-theme-alpine" style={{ height: '400px', width: '99%' }}>
            <h3 className="heading">Invoices</h3>
            <AgGridReact columnDefs={arcolumnnames} rowData={intGridData} animateRows={true}
              ref={agIntGridRef}
              rowSelection={isMultiSelect ? 'multiple' : 'single'}
              pagination={true}
              paginationPageSize={12}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              onRowSelected={handleCheckboxChangeInt}
              suppressRowClickSelection={true}
              quickFilterText={searchText}
              onGridReady={onGridReadyInt} 
              rowHeight={30}/>

          </div>
        </div>
      </div>
      <LoaderComponent loaderOpen={loaderOpen} />

      <Modal
        show={show3}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={modelcolumnnames}
              rowData={modelcolumnnames1}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show5}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={remarkscol}
              rowData={modelnames1}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
        
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show6}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={remarkscol1}
              rowData={remarksdata1}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReconSummary;
